import { module } from 'modujs';
import { $html } from '../utils/dom'
import { CUSTOM_EVENT } from '../config';
import * as focusTrap from 'focus-trap';

export default class Menu extends module {

    static CLASS = {
        OPEN: `has-menu-open`
    }

    constructor(m) {
        super(m);

        // Binding
        this.toggle             = this.toggle.bind(this)
        this.onActivate         = this.onActivate.bind(this)
        this.onDeactivate       = this.onDeactivate.bind(this)
        this.onVisitStart       = this.onVisitStart.bind(this)

        // UI
        this.$el        = this.el
        this.$container = this.$('container')[0]
        this.$togglers  = document.querySelectorAll('[data-menu-toggler]')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        this.focusTrap = focusTrap.createFocusTrap(
            [this.$container, '.c-header'],
            {
                onActivate:   this.onActivate,
                onDeactivate: this.onDeactivate,
                clickOutsideDeactivates: true,
            }
        );
    }

    destroy() {
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener(CUSTOM_EVENT.VISIT_START, this.onVisitStart)

        for (const $toggler of this.$togglers) {
            $toggler.addEventListener('click', this.toggle)
        }
    }

    unbindEvents() {
        window.removeEventListener(CUSTOM_EVENT.VISIT_START, this.onVisitStart)

        for (const $toggler of this.$togglers) {
            $toggler.removeEventListener('click', this.toggle)
        }
    }

    ///////////////
    // Callbacks
    ///////////////
    onActivate() {
        $html.classList.add(Menu.CLASS.OPEN)
        this.$el.setAttribute('aria-hidden', false)

        for (const $toggler of this.$togglers) {
            $toggler.setAttribute('aria-expanded', true)
        }

        // Send custom event
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.MENU_OPEN))
    }

    onDeactivate() {
        $html.classList.remove(Menu.CLASS.OPEN)
        this.$el.setAttribute('aria-hidden', true)

        for (const $toggler of this.$togglers) {
            $toggler.setAttribute('aria-expanded', false)
        }
    }

    onVisitStart(e) {
        // Close menu
        this.focusTrap?.deactivate()
    }

    ///////////////
    // Methods
    ///////////////

    toggle() {
        if($html.classList.contains(Menu.CLASS.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.focusTrap?.activate()
    }

    close() {
        this.focusTrap?.deactivate()
    }
}